/**
 * @generated SignedSource<<4b45390566ab2a7404857c618a574160>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceLayoutPrimary_viewer$data = {
  readonly itemRead: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedOriginalLanguageProvider_item" | "usePdpRecentHistoryTracker_item">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceContainerPrimary_viewer" | "PdpRespMarketplaceLayoutPrimaryContextProvider_viewer">;
  readonly " $fragmentType": "PdpRespMarketplaceLayoutPrimary_viewer";
};
export type PdpRespMarketplaceLayoutPrimary_viewer$key = {
  readonly " $data"?: PdpRespMarketplaceLayoutPrimary_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceLayoutPrimary_viewer">;
};

import PdpRespMarketplaceLayoutPrimaryRefetchQuery_graphql from './PdpRespMarketplaceLayoutPrimaryRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "afterDisplayOrBtSsr"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchPages"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchTypes"
    },
    {
      "kind": "RootArgument",
      "name": "isEstimateSimilarSoldVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isInteractivePdpChat"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpImageGalleryRedesignVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSimilarSoldItemsModuleVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    {
      "kind": "RootArgument",
      "name": "personalizationId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "similarItemsCount"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "userIds"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": PdpRespMarketplaceLayoutPrimaryRefetchQuery_graphql
    }
  },
  "name": "PdpRespMarketplaceLayoutPrimary_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespMarketplaceContainerPrimary_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespMarketplaceLayoutPrimaryContextProvider_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "usePdpRecentHistoryTracker_item"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedOriginalLanguageProvider_item"
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "acee2177c0e71ad0b9f2663e758bf74e";

export default node;
